import Component from './TwitterAnalyticsPublicCampaign.vue'
export default Component
